import { apiFetch } from '../../api/client';
import { withUnidade } from '../../utils/storageByUnit';

export function shUrl(path, unidadeSelecionada) {
  if (!unidadeSelecionada?.codigo) {
    throw new Error('Selecione uma unidade para usar o Safety Huddle.');
  }
  return withUnidade(path, unidadeSelecionada);
}

export async function shJson(path, unidadeSelecionada, options = {}) {
  const res = await apiFetch(shUrl(path, unidadeSelecionada), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || data.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

/** Upload multipart (planilha) — não define Content-Type (boundary automático). */
export async function shForm(path, unidadeSelecionada, formData, method = 'POST') {
  const res = await apiFetch(shUrl(path, unidadeSelecionada), {
    method,
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.error || data.message || `HTTP ${res.status}`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
